import * as React from 'react';
import { RouteComponentProps } from 'react-router';

import PaymentMethodsTable from './PaymentMethodsTable';

import GetCurrenciesQuery from '../../components/Query/Currencies';

interface IPaymentMethodsProps extends RouteComponentProps<{
  eshop: string;
  paymentMethodId: string;
}> {

}

export default class PaymentMethods extends React.Component<IPaymentMethodsProps> {

  constructor(props: any) {
    super(props);
  }

  public render() {
    return (
      <GetCurrenciesQuery>
        {({ primaryCurrency }: any) => (
          <PaymentMethodsTable
            domain={this.props.match.params.eshop}
            paymentMethodId={this.props.match.params.paymentMethodId}
            currency={primaryCurrency}
          />
        )}
      </GetCurrenciesQuery>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/PaymentMethods/index.tsx